<div class="quantity-field"
     [ngClass]="{
         'square': configurationModel.app()?.firstTierButtonShape === ButtonShape.SQUARE,
         'rounded': configurationModel.app()?.firstTierButtonShape === ButtonShape.ROUNDED,
         'oval': configurationModel.app()?.firstTierButtonShape === ButtonShape.OVAL,
         'transparent': transparent()
     }">
    @if (readOnly()) {
        <div class="quantity-field-label">
            {{ 'woa.label.common.qty' | translate }}
        </div>
    } @else {
        <woa-icon-button [type]="IconButtonType.DECREMENT"
                         [disabled]="decrementDisabled() || quantity() <= minQuantity()"
                         [unavailable]="decrementUnavailable()"
                         [limitClickRate]="false"
                         (onActivate)="decrement()"></woa-icon-button>
    }
    <div class="quantity-field-value">
        {{ quantity() }}
    </div>
    @if (!readOnly()) {
        <woa-icon-button [type]="IconButtonType.INCREMENT"
                         [disabled]="incrementDisabled() || quantity() >= maxQuantity()"
                         [unavailable]="incrementUnavailable()"
                         [limitClickRate]="false"
                         (onActivate)="increment()"></woa-icon-button>
    }
</div>
